var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"height":"100%"},attrs:{"fluid":""}},[_c('List')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }